import { UPDATE_LANGUAGE } from "../actions/i18nAction";

const defaultState = {
    lang:  "EN",
};

const i18nReducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_LANGUAGE:
            return {
                ...state,
                lang: action.lang,
            };
        default:
            return state;
    }
}

export default i18nReducer;